// extracted by mini-css-extract-plugin
module.exports = {"board":"Jobs-module--board--RoRHd"};